const pisDeployment = {
    bindings: {
    },
    templateUrl: '/modules/pis-tool/deployment/pis-deployment.html',
    controller: 'PisDeploymentController',
};

angular
    .module('pis-tool.module')
    .component('pisDeployment', pisDeployment)
    .config(function($stateProvider) {
        $stateProvider.state('pis.deployment', {
            url: '/deployment',
            views: {
                'pisview@pis': 'pisDeployment',
            },
            resolve: {
                // workSpaces: PISService => PISService.getAllWorkspaces(),
            },
        });
    });
